import { inject } from '@angular/core';

import { injectQuery } from '@tanstack/angular-query-experimental';

import { firstValueFrom } from 'rxjs';

import { NomenclatureApiService } from '../services/nomenclature-api.service';

/**
 * Selectable LLM models.
 *
 * The catalogue changes only when a model is added, withdrawn or reaches its
 * vendor retirement date - none of which happen mid-session - so this is cached
 * generously. It is refetched on reload, which is soon enough for a list whose
 * entries are governed server-side anyway: picking a withdrawn model is refused
 * by the backend regardless of what this query last returned.
 */
export function injectLlmModelsQuery() {
  const api = inject(NomenclatureApiService);

  return injectQuery(() => ({
    queryKey: ['nom', 'llm_models'],
    queryFn: () => firstValueFrom(api.getLlmModels()),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 3,
  }));
}
